export default function genererIndexationTiers() {
  return {
    tiersType: null,
    tiersId: null,
    specialisationTiersId: null,
    pourcentageIndexationParDefaut: 0,
    tiers: {
      nomCommercial: '',
    },
    specialisationTiers: {
      nomCommercial: '',
    },
    indexationId: null,
  };
}
